import React, { Component } from "react";
import { LicensePlatePublicDetail } from './LicensePlatePublicDetail';
import { NavMenu } from "./NavMenu";
import { StateList } from './StateList';


const labelStyle = {
    width: '140px',
    textAlign: 'right',
    marginRight: '5px'
};



//function formatDate(newDate) {
//    const months = {
//        0: "January",
//        1: "February",
//        2: "March",
//        3: "April",
//        4: "May",
//        5: "June",
//        6: "July",
//        7: "August",
//        8: "September",
//        9: "October",
//        10: "November",
//        11: "December"
//    };
//    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//    const d = new Date(newDate);
//    const year = `${d.getFullYear()}`.substr(2);
//    const date = d.getDate();
//    const monthIndex = d.getMonth();
//    const monthName = months[d.getMonth()];
//    const dayName = days[d.getDay()]; // Thu
//    const minutes = `${(d.getMinutes() < 10 ? '0' : '')}${d.getMinutes()}`;

//    //const formatted = `${dayName}, ${date} ${monthName} ${year}`;
//    //const formatted = `${d.getMonth()}/${date}/${year} ${d.getHours()}:${minutes}`;

//    const formatted = format(d, 'M/d/yy H:mm');



//    return formatted.toString();
//}




export class LicensePlateSearch extends Component {
    static displayName = LicensePlateSearch.name;

    constructor(props) {
        super(props);
        this.state = { LicensePlate: '', LicensePlateState: '', Items: [], Loaded: false };
        this.setLicensePlateState = this.setLicensePlateState.bind(this);
        this.submitForm = this.submitForm.bind(this);
        //this.formatDate = this.formatDate.bind(this);
    }

    componentDidMount() {
        document.title = "Ranger - License plate search";

        // since this is a standalone screen used by the public,
        // we don't want to show them a navigation menu
        NavMenu.hideMenu();
    }

    // as an example of one way to set state
    setLicensePlateState(value) {
        this.setState({
            //LicensePlate: this.state.LicensePlate,
            LicensePlateState: value
        });
    }




    submitForm() {
        console.log(`LP=${this.state.LicensePlate}, state=${this.state.LicensePlateState}`);

        if (this.state.LicensePlate == '' || this.state.LicensePlateState == '') {
            return;
		}

        fetch("/pp/reportService.asmx/listPlateViolationsAcrossCompanies", {
            method: 'POST',
            body: JSON.stringify({
                req: {
                    license: this.state.LicensePlate,
                    licenseState: this.state.LicensePlateState
                }
            }),
            headers: {
                "Content-Type": "application/json"
                //,"Origin": "localhost:3000",
            }
        })
        .then(r => r.json())
        //.then(r => { console.log(r) });
        .then(r => {
                this.setState({
                    Items: r.d.Violations,
                    Loaded: true
                });
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                this.setState({
                    Loaded: true,
                    error
                });
            }
        );
        var i = 0;
    }




    // this has to be static to be used to write sub-content
    static renderList(items) {
        if (items.length == 0) {
            return ('No violations were found');
        } else {
            // examples of how to format cell
            // http://jsfiddle.net/VcAJR/, https://stackoverflow.com/questions/18086468/align-text-to-right-in-td-tag
            return (
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>Violation(s)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(item =>
                            <LicensePlatePublicDetail LicensePlate={item} />
                        )}
                    </tbody>
                </table>
            );
        }
    }




    render() {
        let contents = '';
        if (this.state.Loaded) {
            contents = LicensePlateSearch.renderList(this.state.Items);
        }

        return (
            <div>
                <h1>License plate search</h1>

                <form>
                    <label style={labelStyle} htmlFor="LicensePlate">License plate:</label>
                    <input
                        type="text"
                        id="LicensePlate"
                        name="LicensePlate"
                        value={this.state.LicensePlate}
                        style={{width: '100px'}}
                        onChange={(e) => this.setState({ LicensePlate: e.target.value })}
                    />
                    <br />
                    <label style={labelStyle} htmlFor="LicensePlateState">License plate state:</label>
                    <select
                        id="LicensePlateState"
                        name="LicensePlateState"
                        style={{ width: '100px' }}
                        onChange={(e) => this.setLicensePlateState(e.target.value)}
                    >
                        <StateList />
                    </select>
                </form>

                <button className="btn btn-primary" onClick={this.submitForm}>Submit</button>
                <br />
                {contents}
            </div>
        );
    }
}
